﻿<script setup lang="ts">
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';

import MultiViewLayout from 'src/components/layouts/MultiViewLayout.vue';

import TheAbandonModal from '@/components/TheAbandonModal.vue';

const showAbandon = ref(false);

import TheContactModal from '@/components/TheContactModal.vue';
const showContact = ref(false);
import { PIQSetupPages} from '@/services/piqSetupService.ts';

const router = useRouter();
const {t} = useI18n();

async function yesClick() {
  router.push({name: `PIQSetup.${PIQSetupPages.CanaryHBSVersion}`}).catch(() => {  });
}

async function onAbandonClick() {
  showAbandon.value = !showAbandon.value;
}

async function onInfoClick() {
  showContact.value = !showContact.value;
}

</script>

<template>
  <q-page padding class="canary setup intro2">
    <MultiViewLayout :onBackClick="onAbandonClick" back-icon-list="fa-solid fa-house-circle-xmark" :box-padding="$zb.enums.BoxPaddingEnum.p303048">
      <template v-slot:title>
        {{ t('hbs_flow_title') }}
      </template>

      <template v-slot:auxiliary>
        <zbm-btn-icon @click="onInfoClick()" icon="fa-regular fa-question-circle" size="24px" text-color="dark-teal"/>
      </template>
      <!-- View Unique Content -->
      <template #default>
        <div class="row justify-center">
          <div class="col-6 q-pb-lg">
            <q-img src="img/baseStation/base-station-select.png"/>
          </div>
          <div class="col-11">
            <p class="text-center text-content-txt-secondary">{{t('hbs_segment2_intro_body')}}</p>
          </div>

          <div class="col-6">
            <p class="text-center text-footer-alert semibold" style="margin-top: 48px">{{t('hbs_segment2_intro_footer')}}</p>
          </div>

        </div>
        <div class="row justify-center q-pt-lg">
          <div class="col q-pt-lg self-end">
            <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accent" :label="t('Yes, let’s get set up!')" :outline="true"
                     :width="$zb.enums.ButtonWidthEnum.wFull" :height="$zb.enums.ButtonHeightEnum.lg"
                     @click="yesClick"/>
          </div>
          </div>
        <div class="row justify-center q-pt-sm">
          <div class="col self-end">
            <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accentText" :label="t('I don\'t have mine yet')" :outline="true"
                     :width="$zb.enums.ButtonWidthEnum.wFull" :height="$zb.enums.ButtonHeightEnum.lg"
                     @click="onAbandonClick"/>
          </div>
        </div>

      </template>
    </MultiViewLayout>

    <the-abandon-modal v-model="showAbandon"/>

    <the-contact-modal v-model="showContact"/>
  </q-page>
</template>

